import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  AiOutlineShoppingCart,
  AiOutlinePlus,
  AiOutlineMinus,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  incrementQuantity,
  decrementQuantity,
} from "../redux/features/cartSlice";
import { buildSrcSet } from "../utils/imageUrl";

const ProductCard = ({ id, title, image, weight, description }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [cartCount, setCartCount] = useState(0);

  // Get the item from Redux store
  const cartItem = useSelector((state) =>
    state.cart.cartItems.find((item) => item.id === id)
  );

  // console.log('cartItem',cartItem);

  // Handle Add to Cart
  const handleAddToCart = (e) => {
    e.stopPropagation();
    setCartCount(1); // Add item and start with 1 quantity
  };

  // Increase item count
  const incrementCount = (e) => {
    e.stopPropagation();
    setCartCount(cartCount + 1);
  };

  // Decrease item count or remove if 0
  const decrementCount = (e) => {
    e.stopPropagation();
    if (cartCount > 1) {
      setCartCount(cartCount - 1);
    } else {
      setCartCount(0); // Remove from cart
    }
  };

  return (
    <div className="col-span-12 justify-items-center">
      <div className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer">
        <div className="w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-white-800 dark:border-white-700">
          {/* {console.log("image", image)} */}
          {/* <a href={image || "/placeholder-image.jpg"}>
            <img
              className="rounded-t-lg"
              src={image || "/placeholder-image.jpg"}
              alt={title}
            />
          </a> */}

          <Link
            to={image || "/placeholder-image.jpg"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={image || "/placeholder-image.jpg"}
              srcSet={buildSrcSet(image) || undefined}
              sizes="(min-width: 640px) 448px, 90vw"
              alt={title ?? "Item image"}
              loading="lazy"
              decoding="async"
              className="rounded-t-lg"
            />
          </Link>
          <div className="px-5 pb-5">
            <a href="#">
              <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-black">
                {title || "Product Title"} ( Weight: {weight || ""})
              </h5>
            </a>
            <div className="flex items-center mt-2.5 mb-5">
              <p className="text-gray-700 dark:text-black-400 text-sm">
                {description || ""}
              </p>
            </div>
            <div className="mt-4 flex items-center justify-between p-1">
              <div>
                {weight && cartItem?.quantity > 0 && (
                  <p className="text-gray-600 text-sm">
                    Total Weight: <br />
                    {parseFloat(weight) * (cartItem?.quantity || 0)} gm
                  </p>
                )}
              </div>
              <div>
                {!cartItem ? (
                  // Show Add to Cart if item not added
                  <button
                    onClick={() =>
                      dispatch(addToCart({ id, title, image, weight }))
                    }
                    className="bg-[#AD826D]  hover:opacity-75 text-white p-2 rounded-full flex items-center justify-center"
                  >
                    <AiOutlineShoppingCart size={20} />
                  </button>
                ) : (
                  // Show Counter if item added
                  <div className="flex items-center space-x-1 border rounded-3xl">
                    <button
                      onClick={() => dispatch(decrementQuantity({ id }))}
                      className=" text-dark px-2 py-1 rounded-md"
                    >
                      −
                    </button>
                    <span className="text-sm font-bold">
                      {cartItem.quantity}
                    </span>
                    <button
                      onClick={() => dispatch(incrementQuantity({ id }))}
                      className=" text-dark px-2 py-1 rounded-md"
                    >
                      +
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
